import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { T } from "../theme";

import { useSession } from "../session";

// The header around the list and the workspace. Only a signed-in admin gets
// here (App's AdminOnly); the server checks the role on every call.
export default function AdminShell() {
  const location = useLocation();
  const { me, signOut } = useSession();
  const path = location.pathname;
  const onOverview = path === "/admin" || path === "/admin/";
  const onEngagements = !onOverview; // the list and every workspace
  return (
    <div style={{ minHeight: "100vh", background: T.bgSurface, fontFamily: T.fontSans }}>
      <div className="admin-header" style={{ background: T.bgInverse, padding: "10px 40px 0" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: T.fgOnDark, fontSize: 15, fontWeight: 700 }}><span style={{ display: "block", color: T.canopy, fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" }}>Thread Hub</span>Admin</div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 12, color: T.canopy }}>
            {me && me.email && <span className="admin-who">{me.email}</span>}
            <button onClick={signOut} style={{ fontSize: 12, color: T.canopy, background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: T.fontSans }}>Sign out</button>
          </div>
        </div>
        <nav style={{ display: "flex", gap: 4, marginTop: 6 }}>
          {[["/admin", "Overview", onOverview], ["/admin/engagements", "Engagements", onEngagements]].map(([to, label, on]) => (
            <Link key={to} to={to} style={{ padding: "8px 14px", fontSize: 13, fontWeight: 600, textDecoration: "none", color: on ? T.fgOnDark : T.canopy, borderBottom: `2px solid ${on ? T.threadline : "transparent"}` }}>{label}</Link>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
